import { ACHProcessorData } from "globalConstants";

import { createCustomEnum } from "../customEnum";

const HowDoYouReceivePaymentAuthTypes = createCustomEnum({
	SignedContract: {
		value: ACHProcessorData.PaymentAuthorizationType.SignedContract.value,
		name: ACHProcessorData.PaymentAuthorizationType.SignedContract.value,
		displayName:
			ACHProcessorData.PaymentAuthorizationType.SignedContract
				.displayName,
	},
	Online: {
		value: ACHProcessorData.PaymentAuthorizationType.Online.value,
		name: ACHProcessorData.PaymentAuthorizationType.Online.value,
		displayName:
			ACHProcessorData.PaymentAuthorizationType.Online.displayName,
	},
	Both: {
		value: ACHProcessorData.PaymentAuthorizationType.Both.value,
		name: ACHProcessorData.PaymentAuthorizationType.Both.value,
		displayName: ACHProcessorData.PaymentAuthorizationType.Both.displayName,
	},
});

export default HowDoYouReceivePaymentAuthTypes;
